import { z } from "zod";
import type { ApiPageField } from "../types/api.types";

export type DynamicFormData = Record<string, string>;

export function buildFieldSchema(field: ApiPageField): z.ZodTypeAny {
	let schema: z.ZodTypeAny;

	switch (field.field_type) {
		case "email":
			if (field.is_required) {
				schema = z
					.string()
					.min(1, `${field.label} is required`)
					.refine((val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val), {
						message: "Please enter a valid email address",
					});
			} else {
				schema = z
					.string()
					.optional()
					.refine(
						(val) =>
							!val || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
						{ message: "Please enter a valid email address" },
					);
			}
			break;

		case "tel":
			if (field.is_required) {
				schema = z
					.string()
					.min(1, `${field.label} is required`)
					.refine(
						(val) => /^\+?[\d\s\-().]{7,20}$/.test(val),
						{ message: "Please enter a valid phone number" },
					);
			} else {
				schema = z
					.string()
					.optional()
					.refine(
						(val) =>
							!val || /^\+?[\d\s\-().]{7,20}$/.test(val),
						{ message: "Please enter a valid phone number" },
					);
			}
			break;

		case "url":
			if (field.is_required) {
				schema = z
					.string()
					.min(1, `${field.label} is required`)
					.refine((val) => /^https?:\/\/.+/.test(val), {
						message:
							"Please enter a valid URL (e.g. https://example.com)",
					});
			} else {
				schema = z
					.string()
					.optional()
					.refine(
						(val) =>
							!val ||
							val.length === 0 ||
							/^https?:\/\/.+/.test(val),
						{
							message:
								"Please enter a valid URL (e.g. https://example.com)",
						},
					);
			}
			break;

		case "textarea":
		case "text":
		default:
			if (field.is_required) {
				schema = z.string().min(1, `${field.label} is required`);
			} else {
				schema = z.string().optional();
			}
			break;
	}

	return schema;
}
